import { VideoEmbed } from '../components/VideoEmbed';
import { buildGoogleMapsUrl } from '../utils/maps';

const fbPageUrl = 'https://www.facebook.com/ElfahmawiBoxingCenter/';
const bgUrl = 'https://graph.facebook.com/ElfahmawiBoxingCenter/picture?type=large';

const address = 'أم الفحم - الميدان، 3001000';
const mapsUrl = buildGoogleMapsUrl(address);

export function AlMaydanPage() {
  return (
    <div className="container" style={{ display: 'grid', gap: 16 }}>
      <section className="locationHeader">
        <div className="locationHeaderBg" style={{ backgroundImage: `url("${bgUrl}")` }} />
        <div className="locationHeaderContent">
          <div className="pillRow">
            <span className="badge">فرع</span>
            <span className="badge">الميدان</span>
          </div>
          <h1 className="locationTitle">مركز الملاكمة الفحماوي - الميدان</h1>
          <p className="muted" style={{ margin: 0, lineHeight: 1.9 }}>
            {address}
          </p>
          <div className="actions">
            <a className="btn btnPrimary" href={mapsUrl} target="_blank" rel="noreferrer">
              افتح في خرائط جوجل
            </a>
            <a className="btn" href={fbPageUrl} target="_blank" rel="noreferrer">
              افتح صفحة فيسبوك
            </a>
          </div>
          <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.9 }}>
            ملاحظة: فيسبوك يمنع عرض الصور مباشرة كخلفية في مواقع خارجية أحيانًا، لذلك نستخدم
            صورة تعمل دائمًا مع رابط صفحة فيسبوك.
          </p>
        </div>
      </section>

      <section className="grid2">
        <div style={{ display: 'grid', gap: 14 }}>
          <VideoEmbed
            title="فيديو تيك توك 1"
            url="https://www.tiktok.com/@ameragbaria/video/7623099530036170004"
          />
          <VideoEmbed
            title="فيديو تيك توك 2"
            url="https://www.tiktok.com/@ameragbaria/video/7623055218950917396"
          />
        </div>

        <aside className="card section">
          <div className="titleRow">
            <h2 className="h2">الموقع</h2>
            <span className="badge">خرائط</span>
          </div>
          <p className="muted" style={{ margin: 0, lineHeight: 1.95 }}>
            {address}
          </p>
          <hr className="hr" />
          <div className="actions">
            <a className="btn btnPrimary" href={mapsUrl} target="_blank" rel="noreferrer">
              افتح في خرائط جوجل
            </a>
          </div>
        </aside>
      </section>
    </div>
  );
}

